import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

const AddGroupModal = ({ onClose, handleSubmit, type, selectedGroup }) => {
  const [name, setName] = useState("");
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleNameChange = (e) => {
    setName(e.target.value);

    if (error && e.target.value.trim()) {
      setError("");
    }
  };

  useEffect(() => {
    if (type === "edit") {
      setName(selectedGroup.name);
      setStatus(selectedGroup.status);
    } else {
      setName("");
      setStatus(true);
    }
  }, [selectedGroup]);

  const handleFormSubmit = () => {
    if (!name.trim()) {
      setError("Group name is required");
      return;
    }

    handleSubmit({
      name,
      status,
      onClose,
      setError,
      setLoading,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="relative bg-[rgba(44,52,79,1)] rounded-lg p-6 w-[400px]">
        <h2 className="text-xl font-bold text-white mb-4">
          {type === "edit" ? "Edit Group" : "Add Group"}
        </h2>
        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-white font-bold"
        >
          <FaTimes className="cursor-pointer" />
        </button>
        <div className="mb-4">
          <label
            htmlFor="groupName"
            className="block text-sm font-medium text-white mb-2"
          >
            Group Name
          </label>
          <input
            id="groupName"
            type="text"
            className={`rounded-md p-3 w-full  border rounded-lg border-[rgb(161,147,147)] focus:none focus:outline-none bg-transparent placeholder-sky-400 ${
              error ? "border-red-500" : ""
            } ${name ? "text-white" : ""}`}
            value={name}
            onChange={handleNameChange}
            placeholder="Enter group name"
            autoComplete="off"
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-white mb-2">
            Status
          </label>
          <div className="flex items-center gap-4">
            <label className="flex items-center text-white">
              <input
                type="radio"
                name="status"
                value="active"
                checked={status === true}
                onChange={() => setStatus(true)}
                className="mr-2 bg-primary"
              />
              Active
            </label>
            <label className="flex items-center text-white">
              <input
                type="radio"
                name="status"
                value="inactive"
                checked={status === false}
                onChange={() => setStatus(false)}
                className="mr-2"
              />
              Inactive
            </label>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="bg-transparent border border-gray-400 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleFormSubmit}
            disabled={loading}
            className={`px-4 py-2 rounded text-primary bg-secondary ${
              loading ? "bg-blue-300" : "hover:bg-blue-600"
            } transition`}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGroupModal;
